var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUndo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.978 8.00002C16.7714 8.00578 13.86 9.26936 11.7106 11.3235L9.98247 9.59539C9.25085 8.86378 8 9.38191 8 10.4165V16.9032C8 17.5446 8.51992 18.0645 9.16129 18.0645H15.648C16.6826 18.0645 17.2008 16.8137 16.4692 16.0821L14.449 14.0619C15.9424 12.6636 17.8749 11.889 19.9279 11.8713C24.3988 11.8327 28.1674 15.4508 28.1287 20.0701C28.092 24.4521 24.5395 28.129 20 28.129C18.01 28.129 16.1292 27.4188 14.6469 26.1183C14.4174 25.9169 14.0708 25.9292 13.8549 26.145L11.9358 28.0641C11.7001 28.2999 11.7117 28.6842 11.9591 28.9077C14.087 30.8297 16.9068 32 20 32C26.6274 32 31.9999 26.6274 32 20.0001C32 13.3803 26.5978 7.98816 19.978 8.00002Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUndo);
export default __webpack_public_path__ + "static/media/arrow_undo.77a21be230363de196ca8f48a3943375.svg";
export { ForwardRef as ReactComponent };